import {createSelector} from 'reselect';
import {getTranslations, getListing} from './store';
import {getBrandName, getIsMobile} from './system';
import {isOwnerProfileModalOpen} from './modalStates';
import {getOwnerProfileRoute} from './routes';
import {labelMaker} from '../../server/utils/labelMaker';
import {
    getContact,
    getGeography,
    getHostType,
    getPropertyType,
    getPmProfile,
    getTakesInquiries,
    getThumbnailUrl
} from './listing';
import {getPremierPartnerBadge} from './badges';

const getImage = createSelector(
    [getContact, getThumbnailUrl, getPmProfile],
    (contact = {}, thumbnailUrl, pmProfile) => {
        const ownerPhoto = contact.ownerProfilePhoto;
        const ipmLogo = pmProfile.logoUrl;
        const propertyThumb = thumbnailUrl ? thumbnailUrl.replace('TREATMENT', 'c1') : '';
        const url = ownerPhoto || ipmLogo || propertyThumb;
        const isLogo = !!ipmLogo;

        return {
            url,
            isLogo
        };
    }
);

/* eslint-disable complexity */
const getOwnerDetails = createSelector(
    [
        getListing,
        getTranslations,
        getBrandName,
        getIsMobile,
        isOwnerProfileModalOpen,
        getOwnerProfileRoute,
        getGeography,
        getHostType,
        getPremierPartnerBadge,
        getPropertyType,
        getTakesInquiries,
        getContact,
        getImage
    ],
    (
        listing,
        trans,
        brandName,
        isMobile,
        ownerProfileModalOpen,
        ownerProfileRoute,
        geography,
        hostType,
        premierPartnerBadge,
        propertyType,
        takesInquiries,
        contact = {},
        image
    ) => {
        const {ownersListingProfile} = listing;
        let ownerProfile;
        const contactOwner = hostType.owner ? trans.contactOwner : trans.contactManager;

        const labels = {
            contactOwner,
            languages: `${trans.languages}:`,
            or: trans.or
        };

        let location = '';
        if (geography && geography.name) {
            location = geography.name;
        }

        // Todo - Use lingua keys for fallbacks.
        const contactName = contact.name || (hostType.owner ? trans.owner : trans.propertyManager);

        if (ownersListingProfile) {
            ownerProfile = {
                aboutYou: (ownersListingProfile.aboutYou || '').trim(),
                labels: {
                    modalGenericTitle: contactName,
                    title: labelMaker(trans.ownerProfileAbout, contactName),
                    purchased: ownersListingProfile.yearPurchased
                        ? labelMaker(
                              trans.ownerProfilePurchasedIn,
                              contactName,
                              propertyType,
                              ownersListingProfile.yearPurchased
                          )
                        : '',
                    whyPurchased: labelMaker(trans.ownerProfileWhyPurchased, contactName, location),
                    whyUnique: labelMaker(trans.ownerProfileWhyUnique, propertyType),
                    ownerProfileViewMore: labelMaker(trans.ownerProfileViewMore, contactName),
                    ownerProfileViewLess: labelMaker(trans.ownerProfileViewLess, contactName)
                },
                uniqueBenefits: (ownersListingProfile.uniqueBenefits || '').trim(),
                whyHere: (ownersListingProfile.whyHere || '').trim()
            };
        }

        return {
            ctaAtBottom: !!isMobile,
            image: image.url,
            imageIsLogo: image.isLogo,
            inlineProfile: !isMobile,
            labels,
            memberSince: labelMaker(trans.memberSince, contact.memberSince),
            name: contactName,
            ownerProfileModalOpen,
            ownerProfileRoute,
            ownerProfile,
            premierPartner: premierPartnerBadge,
            languages: contact.languagesSpoken ? contact.languagesSpoken.join(', ') : '',
            takesInquiries
        };
    }
);
/* eslint-enable complexity */

export default getOwnerDetails;
export {getImage, getOwnerDetails};
